module.exports = __webpack_public_path__ + "img/thestocks.im.e27628cf.png";